import { create } from 'zustand'
import { initialStore } from './initialValues'

const useStore = create(set => ({
  fullName: { name: '', lastName: '' },
  streetAddress: '',
  // postalCode: [],
  postalCode: "",
  country: '',
  title: '',
  businessCategories: '',
  currentCompany: '',
  // city: [], // Changed city from string to array
  city: '',
  // state: [],
  state: '',
  sourceURLs: "",
  requiredFields: [],
  downloadData: {
    downloadQueryStore: '',
    download_id: ''
  },
  recordRecency: {
    dateAdded: '',
    dateUpdated: ''
  },
  // R33: New filters for property ownership
  mostRecentPropertyPurchaseDate: {
    startDate: '',
    endDate: ''
  },
  propertiesOwnedDatePurchased: {
    startDate: '',
    endDate: ''
  },
  propertiesOwnedDateSold: {
    startDate: '',
    endDate: '',
    includeNotSold: false
  },
  queryStore: '',
  page: 1,
  firstRender: true,
  dataResults: [], // State to hold the data results
  isQueryLoading: false,
  shouldRefetch: false,
  orFields: [],

  resetStore: () => set(() => ({ ...initialStore, firstRender: true })),
  setIsQueryLoading: loading => set(() => ({ isQueryLoading: loading })),
  setQueryStorePeople: newQuery => set(() => ({ queryStorePeople: newQuery })),
  setPage: newPage => set(() => ({ page: newPage })),
  setFirstRender: value => set(() => ({ firstRender: value })),
  setFullName: (newName, newLastName) =>
    set(() => ({ fullName: { name: newName, lastName: newLastName } })),
  setStreetAddress: newStreetAddress =>
    set(() => ({ streetAddress: newStreetAddress })),
  setTitle: newTitle => set(() => ({ title: newTitle })),
  setBusinessCategories: NewBusinessCategories => set(() => ({ businessCategories: NewBusinessCategories })),
  setCurrentCompany: newCurrentCompany =>
    set(() => ({ currentCompany: newCurrentCompany })),
  setSourceURLs: newSourceURL => set(() => ({ sourceURLs: newSourceURL })),
   setOrFields: newOrFields =>
   set(() => ({ orFields: newOrFields })),

  setCity: newCity => set(() => ({ city: newCity })),
  setState: newState => set(() => ({ state: newState })),

  setPostalCode: newPostalCode => set(() => ({ postalCode: newPostalCode })),

  setDownloadQueryStore: ({ query, id }) =>
    set(state => ({
      downloadData: {
        ...state.downloadData,
        downloadQueryStore: query,
        download_id: id
      }
    })),

  setCountry: newCountry => set(() => ({ country: newCountry })),
  setQueryStore: newQuery => set(() => ({ queryStore: newQuery })),
  setDataResults: newData => set(() => ({ dataResults: newData })),
  setShouldRefetch: (value) => set(() => ({ shouldRefetch: value })),
  setRequiredFields: newRequiredFields =>
    set(() => ({ requiredFields: newRequiredFields })),

  setRecordRecency: (newDateAdded, newDateUpdated) =>
    set(state => ({
      recordRecency: {
        dateAdded: newDateAdded || state.recordRecency.dateAdded,
        dateUpdated: newDateUpdated || state.recordRecency.dateUpdated
      }
    })),

  // R33: Setters for new property ownership filters
  setMostRecentPropertyPurchaseDate: (newStartDate, newEndDate) =>
    set(state => ({
      mostRecentPropertyPurchaseDate: {
        startDate: newStartDate !== undefined ? newStartDate : state.mostRecentPropertyPurchaseDate.startDate,
        endDate: newEndDate !== undefined ? newEndDate : state.mostRecentPropertyPurchaseDate.endDate
      }
    })),

  setPropertiesOwnedDatePurchased: (newStartDate, newEndDate) =>
    set(state => ({
      propertiesOwnedDatePurchased: {
        startDate: newStartDate !== undefined ? newStartDate : state.propertiesOwnedDatePurchased.startDate,
        endDate: newEndDate !== undefined ? newEndDate : state.propertiesOwnedDatePurchased.endDate
      }
    })),

  setPropertiesOwnedDateSold: (newStartDate, newEndDate, newIncludeNotSold) =>
    set(state => ({
      propertiesOwnedDateSold: {
        startDate: newStartDate !== undefined ? newStartDate : state.propertiesOwnedDateSold.startDate,
        endDate: newEndDate !== undefined ? newEndDate : state.propertiesOwnedDateSold.endDate,
        includeNotSold: newIncludeNotSold !== undefined ? newIncludeNotSold : state.propertiesOwnedDateSold.includeNotSold
      }
    }))
}))

export default useStore
